//import BinaryReviews from '@/views/binary-reviews/binary-reviews/BinaryReviews.vue'
//import BinaryReview from '@/views/binary-reviews/binary-review/BinaryReview.vue'

// import SeverityReviews from '@/views/severity-reviews/severity-reviews/SeverityReviews.vue'
// import SeverityReview from '@/views/severity-reviews/severity-review/SeverityReview.vue'

// import SeverityReviews2 from '@/views/severity-reviews2/severity-reviews2/SeverityReviews2.vue'
// import SeverityReview2 from '@/views/severity-reviews2/severity-review2/SeverityReview2.vue'
import AnnotationView from '@/views/annotation-view/AnnotationView.vue'
import AnnotationView2 from '@/views/annotation-view2/AnnotationView2.vue'

import GradedAnnotationReview from '@/views/graded-annotation-reviews/graded-annotation-review/GradedAnnotationReview.vue'
import GradedAnnotationReviews from '@/views/graded-annotation-reviews/graded-annotation-reviews-overview/GradedAnnotationReviews.vue'

import LiveGradeReviews from '@/views/live-detection-reviews/live-grade-reviews/live-grade-reviews-overview/LiveGradeReviews.vue'
import LiveGradeReview from '@/views/live-detection-reviews/live-grade-reviews/live-grade-review/LiveGradeReview'

import TrainingGradeReviews from '@/views/training-grade-reviews/training-grade-reviews-overview/TrainingGradeReviews.vue'
import TrainingGradeReview from '@/views/training-grade-reviews/training-grade-review/TrainingGradeReview.vue'

const commonReviewerRoutes = [
  {
    path: '/live-grade-reviews',
    name: 'LivegradeReviews',
    component: LiveGradeReviews
  },
  {
    path: '/live-grade-reviews/:uuid',
    name: 'LivegradeReview',
    component: LiveGradeReview
  },
  {
    path: '/annotation-view/:uuid',
    name: 'AnnotationView',
    component: AnnotationView,
  },
  {
    path: '/annotation-view2/:uuid',
    name: 'AnnotationView2',
    component: AnnotationView2,
  },
].map(route => ({
  ...route,
  meta: {
    auth: true,
    roles: ['reviewer', 'trainee', 'admin']  // Although targeted reviewers, admins are also allowed
  }
}))

const reviewerTraineeRoutes = [
  {
    path: '/training-grade-reviews',
    name: 'TraininggradeReviews',
    component: TrainingGradeReviews
  },
  {
    path: '/training-grade-reviews/:uuid',
    name: 'TraininggradeReview',
    component: TrainingGradeReview
  },
].map(route => ({
  ...route,
  meta: {
    auth: true,
    roles: ['trainee', 'admin']  // Although targeted reviewers, admins are also allowed
  }
}))

const reviewerRoutes = [
  // {
  //   path: '/binary-reviews',
  //   name: 'BinaryReviews',
  //   component: BinaryReviews
  // },
  // {
  //   path: '/Binary-reviews/:uuid',
  //   name: 'BinaryReview',
  //   component: BinaryReview
  // },
  // {
  //   path: '/severity-reviews',
  //   name: 'SeverityReviews',
  //   component: SeverityReviews
  // },
  // {
  //   path: '/Severity-reviews/:uuid',
  //   name: 'SeverityReview',
  //   component: SeverityReview
  // },
  // {
  //   path: '/severity-reviews2',
  //   name: 'SeverityReviews2',
  //   component: SeverityReviews2
  // },
  // {
  //   path: '/Severity-reviews2/:uuid',
  //   name: 'SeverityReview2',
  //   component: SeverityReview2
  // },
  {
    path: '/graded-annotation-reviews',
    name: 'GradedAnnotationReviews',
    component: GradedAnnotationReviews,
  },
  {
    path: '/graded-annotation-reviews/:uuid',
    name: 'GradedAnnotationReview',
    component: GradedAnnotationReview,
  },
].map(route => ({
  ...route,
  meta: {
    auth: true,
    roles: ['reviewer', 'admin']  // Although targeted reviewers, admins are also allowed
  }
}))

export default [
  ...commonReviewerRoutes,
  ...reviewerTraineeRoutes,
  ...reviewerRoutes,
]